<template>
    <div>
        <!-- <pre>{{ permissions }}</pre> -->
        <template v-if="action == 'view'">
            <div class="table-settings mb-4" v-if="allData.count > 0">
                <div class="row align-items-center justify-content-between">
                    <div class="col col-md-6 col-lg-3 col-xl-4">
                    </div>
                    <div class="col-4 col-md-2 col-xl-1 pl-md-0 text-right">
                    </div>
                </div>
            </div>
            <div class="card border-light shadow-sm mb-4">
                <div style="position: absolute; margin-top: 120px; z-index: 1; width: max-content; left: 50%; transform: translate(-50%, 0%);"
                    v-if="!permissions.find(e => e.permission_name == 'View Contact Requests')">
                    <span style="color: red;"><i class="mr-2 fa fa-eye-slash"></i>You dont have the viewing
                        permission.</span>
                </div>
                <div :style="!permissions.find(e => e.permission_name == 'View Contact Requests') ? 'filter: blur(4px); pointer-events: none;' : ''"
                    v-if="loading == false && (allData.count > 0 || q != '')">
                    <table class="table table-hover">
                        <thead class="thead-light">
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Mobile</th>
                                <th>Email</th>
                                <th>Subject</th>
                                <th>Massage</th>
                                <th>Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody v-if="allData.count > 0">
                            <tr v-for="(data, key) in allData.data" :key="key">
                                <td>
                                    <a href="#" class="font-weight-bold">
                                        {{ key + 1 }}
                                    </a>
                                </td>
                                <td><span class="font-weight-normal">{{ data.name }}</span></td>
                                <td> {{ data.mobile }}
                                </td>
                                <td> {{ data.email }}
                                </td>
                                <td> {{ data.subject }}
                                </td>
                                <td>
                                    <button class="btn btn-primary btn-sm link"
                                        :disabled="!permissions.find(e => e.permission_name == 'View Messages')"
                                        @click="$modal.show('showModal' + key)"> View Massage </button>
                                    <Modal :name="'showModal' + key" height="auto">
                                        <div class="modal-header">
                                            <h3>
                                                {{ data.name }} Massage
                                            </h3>
                                            <hr>
                                            <a @click="$modal.hide('showModal' + key)">Close</a>
                                        </div>

                                        <div class="card-body">
                                            {{ data.comments }}
                                        </div>

                                        <div slot="modal-footer" class="w-100">
                                            <p class="float-left">Modal Footer Content</p>
                                            <b-btn size="sm" class="float-right" variant="primary"
                                                @click="$modal.hide('showModal')">
                                                Close
                                            </b-btn>
                                        </div>

                                    </Modal>
                                </td>
                                <td><span class="font-weight-normal">{{ data.udate }}</span></td>
                                <td>
                                    <div class="btn-group">
                                        <button
                                            :disabled="!permissions.find(e => e.permission_name == 'Remove Contact Requests')"
                                            @click.prevent="remove(data.id)" class="btn btn-danger btn-xs"
                                            href="#"><span class="fa fa-trash-alt mr-2"></span>Remove</button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td class="text-center" colspan="5">No record found</td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="card-footer px-3 border-0 d-flex align-items-center justify-content-between">
                        <nav aria-label="Page navigation example">
                            <ul class="pagination mb-0">
                                <template v-for="(paginate, key) in allData.links">
                                    <li :key="key" class="page-item" :class="{ 'active': paginate.active }"
                                        v-if="paginate.url">
                                        <a class="page-link" @click="viewAllUrl = paginate.url; allDatas(false)"
                                            v-html="paginate.label"></a>
                                    </li>
                                </template>
                            </ul>
                        </nav>
                        <div class="font-weight-bold small">Page <b>{{ allData.current_page }}</b> of
                            <b>{{ allData.last_page }}</b> page Total
                            record <b>{{ allData.total }}</b></div>
                    </div>
                </div>
                <div class="card-body text-center" v-else>
                    <div v-if="loading">
                        loading...
                    </div>
                    <div v-else>
                        <!-- <InlineSvg name="nopage"></InlineSvg> -->
                        <div>
                            <h3>Add and manage your {{ page }}</h3>
                            <p>This is where you’ll add {{ page }} and manage your website. You can also improve your seo
                                for {{ page }} by
                                adding.</p>
                            <router-link :to="{ name: 'index', params: { page: page, action: 'add' } }"
                                class="btn btn-primary" type="button">Add {{ page }}</router-link>
                            <br><br><br>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="row">
                <div class="col-12 col-xl-8">
                    <div class="card card-body bg-white border-light shadow-sm mb-4">
                        <h2 class="h5 mb-4">General information </h2>
                        <div class="row">
                            <!-- <div class="col-md-6 mb-3">
                                <MssInput v-model="form.linkname" placeholder="Enter Page Link" required></MssInput>
                            </div> -->
                            <div class="col-md-6 mb-3">
                                <MssInput v-model="form.username" placeholder="Enter Fullname" required></MssInput>
                            </div>
                            <div class="col-md-6 mb-3">
                                <MssInput v-model="form.mobile" placeholder="Enter Mobile Number" required></MssInput>
                            </div>
                            <div class="col-md-6 mb-3">
                                <MssInput v-model="form.email" placeholder="Enter Mobile Email" required></MssInput>
                            </div>
                            <div class="col-md-6 mb-3">
                                <MssInput v-model="form.pass" placeholder="Enter password" required></MssInput>
                            </div>
                            <div class="col-md-6 mb-3">
                                <MssInput v-model="form.state" placeholder="Enter State name" required></MssInput>
                            </div>
                            <div class="col-md-6 mb-3">
                                <MssInput v-model="form.city" placeholder="Enter City Name" required></MssInput>
                            </div>
                            <div class="col-md-6 mb-3">
                                <MssInput v-model="form.zip" placeholder="Enter Pincode" required></MssInput>
                            </div>



                        </div>
                    </div>
                </div>
                <div class="col-12 col-xl-4 sidebar-stricky">
                    <div class="card card-body bg-white border-light shadow-sm mb-4">
                        <h2 class="h5 mb-4">Visibility</h2>
                        <div class="row">
                            <div class="col-md-12 mb-3">
                                <MssInput type="switch" v-model="form.status" placeholder="Visible this page to all">
                                </MssInput>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div>
                                    <button @click="submit" class="btn btn-info btn-block"
                                        v-if="action == 'add'">Publish</button>
                                    <button @click="submit" class="btn btn-success btn-block" v-else>Update</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </template>
    </div>
</template>
<script>
import axios from 'axios'
import $ from 'jquery'

export default {
    components: {
    },
    props: [
        "page", "action", "id"
    ],
    data() {
        return {
            isEditor: true,
            q: '',
            loading: false,
            allData: [],
            form: {
                id: null,
                status: true,
                type: 'add_user',
                username: '',
                email: '',
                mobile: '',
                password: '',
                state: '',
                city: '',
                zip: '',
            },
            editSEO: false,
            defaultSEO: true,
            pageList: [],
            fullToolbar: [
                [{ 'font': [] }],
                [{ 'header': [false, 1, 2, 3, 4, 5, 6,] }],
                [{ 'size': ['small', false, 'large', 'huge'] }],
                ['bold', 'italic', 'underline', 'strike'],
                [{ 'align': [false, 'justify', 'center', 'right'] }],
                //[{ 'header': 1 }, { 'header': 2 }],
                //['blockquote', 'code-block'],
                [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'list': 'check' }],
                //[{ 'script': 'sub'}, { 'script': 'super' }],
                [{ 'indent': '-1' }, { 'indent': '+1' }],
                [{ 'color': [] }, { 'background': [] }],
                ['link', 'image', 'video', 'formula'],
                //[{ 'direction': 'rtl' }],
                ['clean'],
            ],
            viewAllUrl: '',
            permissions: null,
        }
    },
    methods: {
        update(table, status, id) {
            var param = {
                id: id,
                status: status,
                table: table,
                type: 'commonStatus'
            }
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'api.php',
                data: param
            }).then(function (response) {
                var data = response.data;
                console.log('status', data)
            })
        },
        addInit() {
            this.getUnderof();
            this.reset()
        },
        editInit() {
            this.getDetail();
            this.getUnderof();
        },
        viewInit() {
            this.viewAllUrl = this.URL_ROOT + 'admin/' + this.page + '/all'
            this.allDatas(true)
        },
        reset() {
            this.form = {
                id: null,
                status: true,
                type: 'add_user',
                username: '',
                email: '',
                mobile: '',
                pass: '',
                state: '',
                city: '',
                zip: '',
            };
        },
        getUnderof() {
            var pList = [];
            pList.push({ label: 'Primary Menu', code: 0 })
            $.ajax({
                "method": 'GET',
                "url": this.URL_ROOT + 'admin/' + this.page + '/allpage/?field=heading,id,underof',
                "success": (response) => {
                    if (response.status == "success") {
                        console.log(response.data);
                        $.each(response.data, function (key, param) {
                            //console.log(param,key);
                            pList.push({ label: param.heading, code: param.id })
                        })
                    }
                    this.pageList = pList;
                }
            })
            /**
             if(this.action=="add"){
                this.from.lorder = response.length+1;
            } */
        },
        getDetail() {
            var ev = this
            var param = {
                uid: this.id,
                type: 'userDetail'
            }
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'api.php',
                data: param
            }).then(function (response) {
                console.log(response.data.data)
                var data = response.data;
                ev.form = data.data
            })
        },
        allDatas() {
            var ev = this
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'api.php',
                data: {
                    type: 'getContact',
                }
            }).then(function (response) {
                var data = response.data;
                ev.allData = data
            })
        },
        submit() {
            var ev = this

            if (this.form.username === '') {
                this.$toasted.global.error({
                    message: 'Please enter Full Name'
                })
            } else if (this.form.email === '') {
                this.$toasted.global.error({
                    message: 'Please enter Email'
                })
            } else if (this.form.mobile === '') {
                this.$toasted.global.error({
                    message: 'Please enter mobile'
                })
            } else if (this.form.pass === '') {
                this.$toasted.global.error({
                    message: 'Please enter password'
                })
            } else if (this.form.state === '') {
                this.$toasted.global.error({
                    message: 'Please enter State'
                })
            } else if (this.form.city === '') {
                this.$toasted.global.error({
                    message: 'Please enter City'
                })
            } else if (this.form.zip === '') {
                this.$toasted.global.error({
                    message: 'Please enter Pincode'
                })
            } else {
                var status = ''
                if (ev.form.status == true) {
                    status = 1
                } else {
                    status = 0
                }
                let formData = new FormData();
                if (this.action == 'edit') {
                    this.form.type = 'edit_user';
                    formData.append('uid', this.id);

                }
                formData.append('fullname', ev.form.username);
                formData.append('mobile', ev.form.mobile);
                formData.append('email', ev.form.email);
                formData.append('password', ev.form.pass);
                formData.append('state', ev.form.state);
                formData.append('city', ev.form.city);
                formData.append('pincode', ev.form.zip);
                formData.append('status', status);
                formData.append('type', ev.form.type);
                axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'api.php',
                    data: formData
                }).then(function (response) {
                    var data = response.data;
                    console.log(response)
                    if (data.status == "success") {
                        ev.$swal({
                            toast: true,
                            position: 'top-end',
                            timer: 5000,
                            icon: 'success',
                            timerProgressBar: true,
                            title: 'Action perform successfully'
                        })
                        ev.$router.push({
                            name: 'index',
                            params: {
                                page: ev.page,
                            }
                        })
                    } else {
                        setTimeout(() => ev.$swal(data.msg), 1000);

                    }

                }
                )
            }
        },
        remove(id) {
            var self = this;
            var param = {
                id: id,
                table: 'mss_contact',
                type: 'commonDelete'
            }
            this.$swal({
                title: "Delete this ?",
                text: "Are you sure? You won't be able to revert this!",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: "#f00",
                confirmButtonText: "Yes, Delete it!",
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    axios({
                        method: 'POST',
                        url: this.$root.URL_ROOT + 'api.php',
                        data: param
                    }).then(function (response) {
                        var data = response.data;
                        self.allDatas()
                        console.log('commonDelete', data)
                    })
                }
            })
        },

    },
    mounted() {
        if (localStorage.getItem('permissions')) {
            const permissionsLS = localStorage.getItem('permissions')
            const permission = JSON.parse(permissionsLS)
            this.permissions = permission.filter(e => e.section == 'CONTACT REQUEST' && e.has_permission == true)
        }
        if (this.action == "view") {
            this.viewInit()
        } else if (this.action == "edit" && this.id > 0) {
            this.editInit()
        } else if (this.action == "add") {
            this.addInit();
        }
    },
    watch: {
        'action': function (val) {
            if (val == "view") {
                this.viewInit()
            } else if (val == "edit" && this.id > 0) {
                this.editInit()
            } else if (val == "add") {
                this.addInit();
            }
        },
    }
}
</script>
<style scoped>
@import "~vue2-editor/dist/vue2-editor.css";
</style>
